export const SET_TIMEDEVENTS = 'SET_TIMEDEVENTS';
export const GET_TIMEDEVENTS = 'GET_TIMEDEVENTS';
